var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tutorial.Ongoing)?_c('div',{staticClass:"skip"},[_c('v-btn',{staticClass:"text-lowercase my-0 py-0",attrs:{"small":"","text":"","elevation":"0","color":"grey lighten-4"},on:{"click":_vm.skipTutorial}},[_vm._v(" "+_vm._s(_vm.$t("action.skipTutorial"))+" "),_c('v-icon',[_vm._v(" mdi-redo ")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }